import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";
import vuetify from './plugins/vuetify'
import VueGtag from "vue-gtag";




Vue.use(Toast, { position: POSITION.TOP_CENTER, timeout: 2000 });

Vue.use(VueGtag, {
  pageTrackerExcludedRoutes: ['login', '/login', 'callback', '/auth/callback'],
  config: { id: 'G-4R6V735GB4' }
}, router)

Vue.config.productionTip = false

// Vue's optimised build disables the DevTools bridge by default. Every environment is now
// built optimised, so without this line the extension would stop attaching on homolog too —
// keep it available everywhere except production.
Vue.config.devtools = process.env.VUE_APP_ENV !== 'production'

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
